export default "__VITE_ASSET__B3o3oERK__"